import { ethers } from "ethers";

import abi from './contractAbi';


export const getContract = () => {
  const provider = new ethers.providers.Web3Provider((window as any).ethereum)
  const contract = new ethers.Contract(process.env.GATSBY_CONTRACT_ADDRESS ?? '', abi, provider);


  // const result = await contract.functions['currentSupply']();

  return contract;
}